import { FC } from 'react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import cn from './index.module.css'
import { Slider, SliderSingleProps } from 'antd'
import classNames from 'classnames'

interface ISliderField extends SliderSingleProps {
  label?: string
  value: number
  extraContent?: string
  tooltipOpen?: boolean
  onChange: (value: number) => void
  isInvalid?: boolean
  className?: string
}

const SliderField: FC<ISliderField> = ({
  label,
  value,
  extraContent,
  tooltipOpen,
  onChange,
  isInvalid,
  className,
  ...props
}) => {
  return (
    <FieldWrapper
      label={label}
      isInvalid={isInvalid}
      extraContent={
        extraContent ? (
          <div className={cn.valueContent}>{extraContent}</div>
        ) : null
      }
    >
      <Slider
        className={classNames(cn.slider, className)}
        value={value}
        onChange={onChange}
        tooltip={{ open: tooltipOpen, prefixCls: cn.tooltip }}
        {...props}
      />
    </FieldWrapper>
  )
}

export default SliderField
